module.exports = {"650205001":"柳树街街道","650205100":"乌尔禾镇","650205509":"兵团一三七团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/650205.json
// module id = 3061
// module chunks = 0